import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';

@Component({
  selector: 'app-merchant-payment',
  templateUrl: './merchant-payment.component.html',
  styleUrls: ['./merchant-payment.component.scss']
})
export class MerchantPaymentComponent implements OnInit {

  payments: any[] = [];

  merchantId: any;

  constructor(
    private apiService: ApiServiceService
  ) { }

 ngOnInit(): void {


this.merchantId =
localStorage.getItem('merchantId');


console.log(
"MERCHANT ID",
this.merchantId
);


this.loadPayments();


}

  loadPayments() {

    this.apiService
      .getMerchantPayments(this.merchantId)
      .subscribe({

        next: (res: any) => {

          console.log(res);

          this.payments = res.data;

        },

        error: (err) => {

          console.log(err);

        }

      });

  }

}